module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"request-error":"Ошибка при получении данных"},"en":{"request-error":"Request error"}}')
  delete Component.options._Ctor
}
